import React, { Children } from "react";
import { RequestState } from "src/models/RequestState";
import { AggregateFilterEntity } from "src/models/AggregateFilterEntity";
import CheckboxTree from 'react-checkbox-tree';
import {Node as CheckboxTreeNode} from 'react-checkbox-tree';
import axios from "axios";
import { Api } from "src/core/api";
import { JsonConvert } from "json2typescript";
import { css } from "aphrodite/no-important";
import { styles } from "./AggregateCollegeStyle";
import { PieChart, Pie, Sector, Cell, ComposedChart, XAxis, YAxis, Tooltip, Bar, BarChart, Legend } from "recharts";
import { AggregateEnity } from "src/models/AggregateEntity";
import { getRandomColor, getColor } from "src/views/Utils";
import millify from 'millify'
import { HorizontalAxisTick } from "src/components/charts/AxisTick";
import { StackedChartTooltip } from "src/components/charts/StackedChartTooltip";
import { CombinedToolTip } from "src/components/CombinedTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus} from "@fortawesome/free-solid-svg-icons";
import { far,faCheckSquare, faSquare, faMinusSquare } from "@fortawesome/free-regular-svg-icons";
import { TreeNodeParent, TreeNodeChild, TreeNodeLeafChild, CheckState } from "src/models/TreeNode";
import { Aggregator } from "react-table";
import { URLBuilder } from "src/core/URLBuilder";

class AggregateCollegeItem {
    public id : number = 0;
    public name: string = "";
    public count: number = 0;
    public color: any = ""
}

enum LEVEL {
    COLLEGE,
    DEPARTMENT,
    FACULTY
}

enum VIEW {
    AWARD,
    PROPOSAL,
    EXPENDITURE,
    PUBLICATION
}

enum AGGREGATE {
    COUNT,
    AMOUNT
}

class HeaderItem {
    public id: number = 0;
    public name: string = ""; 
}

interface IAggregateCollegeProps {
    history: any
}

class AggregateCollegeState {
    public readonly collegeListRequestState: RequestState = RequestState.NOT_ASKED;
    public readonly rawCollegeListData : AggregateFilterEntity[] = []
    public readonly collegeFilterTree: TreeNodeParent[] = [];
    public readonly collegeListError: string = "";
    public readonly checkedNodes: string[] = [];
    public readonly expandedNodes: string[] = [];
    public readonly dataRequestState: RequestState = RequestState.NOT_ASKED;
    public readonly dataError: string = "";
    public readonly rawData: AggregateEnity[] = [];
    public readonly data : AggregateCollegeItem[] = [];
    public readonly activeIndex: number = 0;
    public readonly headers: HeaderItem[] = [];
    public readonly currentLevel: LEVEL = LEVEL.COLLEGE;
    public readonly selectedView: VIEW = VIEW.AWARD;
    public readonly selectedAggregate: AGGREGATE = AGGREGATE.AMOUNT;
    public readonly currentSelectedID: number = 0;

    constructor(){
        //build a default home header
        const homeHeader = new HeaderItem();
        homeHeader.id = 0
        homeHeader.name = "Colleges"
        this.headers.push(homeHeader);
    }

}

export class AggregateCollege extends React.Component<IAggregateCollegeProps, AggregateCollegeState> {

    constructor(props: any){
        super(props);
        this.state = new AggregateCollegeState();
    }
    

    public componentDidMount() {
        //fetch the filter list 
        this.setState({...this.state, collegeListRequestState: RequestState.LOADING})
        axios.get(URLBuilder.college_filter_tree()).then((res)=>{
            try{
                const jsonConvert = new JsonConvert();
                const data : AggregateFilterEntity[] = jsonConvert.deserializeArray(res.data, AggregateFilterEntity);
                // sort the year
                for(const filterItem of data){
                    if(filterItem.name.toLowerCase() === "year"){
                        filterItem.children.sort((item1: AggregateFilterEntity, item2: AggregateFilterEntity)=> +item2.name - +item1.name)
                    }
                }
                const transformedData = this.transformTreeData(data);
                this.setState({...this.state, collegeListRequestState: RequestState.SUCCESS, collegeFilterTree: transformedData, rawCollegeListData: data})
            }catch(error){
                this.setState({...this.state, collegeListRequestState: RequestState.ERROR, collegeListError: error.toString()})    
            }
        }).catch((error)=>{
            this.setState({...this.state, collegeListRequestState: RequestState.ERROR, collegeListError: error.toString()})
        })
        

        //fetch the data
        this.fetchData(LEVEL.COLLEGE, 0, this.buildFilter(this.state.collegeFilterTree));

    }

    private transformTreeData = (data: AggregateFilterEntity[]) => {
        const treeNodes = [];
        let parentIndex = 0;
        for(const parentItem of data){
            const treeNodeParent = new TreeNodeParent();
            treeNodeParent.id = parentItem.entity_id;
            treeNodeParent.label = parentItem.name;

            //create children for parent
            let childIndex = 0;
            for(const childItem of parentItem.children){
                const treeNodeChild = new TreeNodeChild();
                treeNodeChild.id = childItem.entity_id;
                treeNodeChild.label = childItem.name;
                treeNodeChild.parent = parentIndex;
                treeNodeParent.children.push(treeNodeChild);
                
                //create leaf children for child
                for(const leafChildItem of childItem.children){
                    const treeNodeLeafChild = new TreeNodeLeafChild();
                    treeNodeLeafChild.id = leafChildItem.entity_id;
                    treeNodeLeafChild.label = leafChildItem.name;
                    treeNodeLeafChild.parent = childIndex;
                    treeNodeLeafChild.superParent = parentIndex;
                    treeNodeChild.children.push(treeNodeLeafChild);
                }
                
                childIndex = childIndex + 1;
                
            }
            treeNodes.push(treeNodeParent);
            parentIndex = parentIndex + 1;
        }
        return treeNodes;
    }

    public fetchData = (level: LEVEL, entity_id: number, filter: AggregateFilterEntity[]) => {
        this.setState({...this.state, dataRequestState: RequestState.LOADING})

        let url = "";
        if(level === LEVEL.COLLEGE){
            url = URLBuilder.aggregate_college()
        }else if(level === LEVEL.DEPARTMENT){
            url = URLBuilder.aggregate_department(entity_id)
        }else if(level === LEVEL.FACULTY){
            url = URLBuilder.aggregate_faculty(entity_id)
        }
        axios.post(url,filter).then((res)=>{
            try{
                const jsonConvert = new JsonConvert();
                const data : AggregateEnity[] = jsonConvert.deserializeArray(res.data, AggregateEnity);
                // map to the actual aggregate entity for this chart
                const items = this.transformData(this.state.selectedView, this.state.selectedAggregate, data, level);
                this.setState({...this.state, dataRequestState: RequestState.SUCCESS,rawData: data,data: items})
            }catch(error){
                this.setState({...this.state, dataRequestState: RequestState.ERROR, dataError: error.toString()})    
            }
        }).catch((error)=>{
            this.setState({...this.state, dataRequestState: RequestState.ERROR, dataError: error.toString()})
        })
    }

    private transformData = (view: VIEW, aggregate: AGGREGATE, rawData: AggregateEnity[], level: LEVEL) => {

        function selectCount (entity: AggregateEnity ) {
            let count;
            if(aggregate === AGGREGATE.AMOUNT){
                if(view === VIEW.AWARD){
                    count = entity.award_amount; 
                }else if(view === VIEW.EXPENDITURE){
                    count = entity.expenditure_amount;
                }else if(view === VIEW.PROPOSAL){
                    count = entity.proposal_amount;
                }else{
                    count  = 0;
                }
            }else{
                if(view === VIEW.AWARD){
                    count = entity.award_count;
                }else if(view === VIEW.PROPOSAL){
                    count = entity.proposal_count;
                }else if(view === VIEW.PUBLICATION){
                    count = entity.publication_count
                }else{  
                    count  = 0;
                }   
            }
            return count;
        }
        
        let total = 0;
        
        let items = rawData.map((item: AggregateEnity, index: number)=>{
            const collegeItem = new AggregateCollegeItem();
            collegeItem.id = +item.id;
            collegeItem.name = item.name;
            collegeItem.count = +selectCount(item);
            collegeItem.color = getColor(index);
            total = total + collegeItem.count;
            return collegeItem;
        })
        
        if(level !== LEVEL.FACULTY){
            items = this.mergeIntoMisc(items, 0.01);
        }

        items.sort((item1: AggregateCollegeItem, item2: AggregateCollegeItem)=>{
            return item2.count - item1.count;
        })

        return items;
    }

    private mergeIntoMisc = (items: AggregateCollegeItem[], threshold: number) => {
        //get the total for every quantity
        const total = items.map((item:AggregateCollegeItem)=>{
            return item.count;
        }).reduce((sum, count)=>{
            return sum + count;
        });

        //loop over items
        const miscAggregateCollegeItem = new AggregateCollegeItem();
        const reducedItems = []
        for(const item of items){
            //if perc is below threshold
            if((item.count/total)< threshold){
                miscAggregateCollegeItem.count = item.count + miscAggregateCollegeItem.count;
            }else{
                reducedItems.push(item)
            }
        }
        miscAggregateCollegeItem.id = 0;
        miscAggregateCollegeItem.name ="Misc";
        miscAggregateCollegeItem.color = getColor(100);
        if(miscAggregateCollegeItem.count > 0){
            reducedItems.push(miscAggregateCollegeItem)
        }
        return reducedItems;

    }   

    public render() {
        
        let dataContent;

        if(this.state.dataRequestState === RequestState.SUCCESS){
            if(this.state.currentLevel !== LEVEL.FACULTY){
                dataContent = this.renderPieChart(this.state.data)
            }else{
                dataContent = this.renderBarChart(this.state.rawData)
            }
        }else if(this.state.dataRequestState === RequestState.ERROR){
            dataContent = (
                <div>
                    {this.state.dataError}
                </div>
            )
        }else if(this.state.dataRequestState === RequestState.LOADING){
            dataContent = (
                <div>
                    Loading
                </div>
            );
        }else{
            dataContent = (
                <div>

                </div>
            );
        }

        let content;        
        if(this.state.collegeListRequestState === RequestState.SUCCESS){
            
            const header = (
                <div className={css(styles.header)} >
                    {this.state.headers.map(this.buildHeaderItem)}
                </div>
            )

            const aggregateForAwards = this.buildAggregateSection(this.state.selectedView, VIEW.AWARD,this.state.selectedAggregate);
            const aggregateForProposal = this.buildAggregateSection(this.state.selectedView, VIEW.PROPOSAL,this.state.selectedAggregate);
            const aggregateForExpenditure = this.buildAggregateSection(this.state.selectedView, VIEW.EXPENDITURE,this.state.selectedAggregate);
            const aggregateForPublication = this.buildAggregateSection(this.state.selectedView, VIEW.PUBLICATION,this.state.selectedAggregate);

            content = (
                <div id="content" className={css(styles.content)}>
                                        
                    <div id="filter_tree" >
                        <div className={css(styles.filterList)} >
                                {this.state.collegeFilterTree.map(this.buildParentTreeItem)}
                        </div>
                    </div>

                    <div id="pie_content">
                        {header}
                        {dataContent}
                    </div>

                    <div id="views" className={css(styles.views)} >

                        <div className={css(styles.viewTitle)} >
                            View
                        </div>

                        <label className={css(styles.viewOption)} >
                            <input type="radio"
                                   name="view"
                                   className={css(styles.radioButton)}
                                   value={VIEW.AWARD}
                                   checked={this.state.selectedView === VIEW.AWARD}
                                   onChange={this.onViewChange}
                                />
                            Awards
                        </label>
                        {aggregateForAwards}

                        <label className={css(styles.viewOption)} >
                            <input type="radio"
                                   name="view"
                                   className={css(styles.radioButton)}
                                   value={VIEW.PROPOSAL}
                                   checked={this.state.selectedView === VIEW.PROPOSAL}
                                   onChange={this.onViewChange}
                                   />
                            Proposals
                        </label>
                        {aggregateForProposal}

                        <label className={css(styles.viewOption)} >
                            <input type="radio"
                                   name="view"
                                   className={css(styles.radioButton)}
                                   value={VIEW.EXPENDITURE}
                                   checked={this.state.selectedView === VIEW.EXPENDITURE}
                                   onChange={this.onViewChange}
                                   />
                            Expenditures
                        </label>
                        {aggregateForExpenditure}

                        <label className={css(styles.viewOption)} >
                            <input type="radio"
                                   name="view"
                                   className={css(styles.radioButton)}
                                   value={VIEW.PUBLICATION}
                                   checked={this.state.selectedView === VIEW.PUBLICATION}
                                   onChange={this.onViewChange}
                                   />
                            Publications
                        </label>
                        {aggregateForPublication}
                               
                    </div>

                </div>
            );
        }else if(this.state.collegeListRequestState === RequestState.LOADING){
            content = (<div>
                    Loading
                </div>);
        }else if(this.state.collegeListRequestState === RequestState.ERROR) {
            content = (<div>
                    {this.state.collegeListError}
                </div>);
        }else{

        }

        return (<div className={css(styles.page)} >
            {content}
        </div>)    
    }

    private buildAggregateSection = (currentSelectedView: VIEW, targetView: VIEW, currentSelectedAggregate: AGGREGATE) => {
        let countStyle;
        let amountStyle;
        if(currentSelectedView === VIEW.PUBLICATION){
            amountStyle = {

            }
            amountStyle = {
                display: "none"
            }
        }else if(currentSelectedView === VIEW.EXPENDITURE){
            countStyle = {
                display: "none"
            }
        }else{
            amountStyle = {

            }
            countStyle = {

            }
        }
        if(currentSelectedView === targetView){
            return (
                <div id="aggregate" className={css(styles.aggregate)} >
                    <label className={css(styles.viewOption)} style={countStyle}>
                        <input type="radio"
                                name="aggregation"
                                className={css(styles.radioButton)}
                                value={AGGREGATE.COUNT}
                                disabled = {this.isAggregateDisabled(AGGREGATE.COUNT)}
                                checked={this.state.selectedAggregate === AGGREGATE.COUNT}
                                onChange={this.onAggregateChange}
                                />
                        Count
                    </label>
    
                    <label className={css(styles.viewOption)} style={amountStyle} >
                        <input type="radio"
                                name="aggregation"
                                className={css(styles.radioButton)}
                                value={AGGREGATE.AMOUNT}
                                disabled = {this.isAggregateDisabled(AGGREGATE.AMOUNT)}
                                checked={this.state.selectedAggregate === AGGREGATE.AMOUNT}
                                onChange={this.onAggregateChange}
                                />
                        Amount
                    </label>
                </div>
            );
        }else{
            return (<div>

            </div>);
        }
    }

    private onViewChange = (event: any) => {
        const selectedView = +event.target.value;
        let selectedAggregate;
        if(selectedView === VIEW.PUBLICATION){
            selectedAggregate = AGGREGATE.COUNT;
        }else if(selectedView === VIEW.EXPENDITURE){
            selectedAggregate = AGGREGATE.AMOUNT;
        }else{
            selectedAggregate = this.state.selectedAggregate;
        }
        const items = this.transformData(+event.target.value, selectedAggregate, this.state.rawData, this.state.currentLevel);
        this.setState({...this.state,selectedView: +event.target.value, selectedAggregate: selectedAggregate, data: items})
    }

    private onAggregateChange = (event: any) => {
        const items = this.transformData(this.state.selectedView, +event.target.value, this.state.rawData, this.state.currentLevel);
        this.setState({...this.state,selectedAggregate: +event.target.value,data: items})
    }

    private renderPieChart = (data: AggregateCollegeItem[]) => {
        return (
            <PieChart 
                width={900}
                height={500}
                className={css(styles.pieChart)}
                >
                <Pie 
                    activeIndex={this.state.activeIndex}
                    activeShape={<PieActiveShape aggregate={this.state.selectedAggregate} />} 
                    data={data} 
                    innerRadius={135}
                    outerRadius={160} 
                    fill="#8884d8"
                    label={<PieLabel  aggregate={this.state.selectedAggregate} />}
                    labelLine={false}
                    nameKey={"name"}
                    dataKey={"count"}
                    onMouseEnter={this.onPieEnter}
                    onClick={this.onPieClick}
                    isAnimationActive={false}
                    fontSize={0}
                >
                    {
                        data.map((entry, index) => <Cell fill={entry.color} key={index} />)
                    } 
                </Pie>
            </PieChart>
        );
    }

    private onPieEnter = (data: any, index: number) => {
        this.setState({
            activeIndex: index,
        });
    }
    
    private onPieClick = (data: AggregateCollegeItem, index: number) => {
        if(data.id !== 0){
            if(this.state.currentLevel === LEVEL.COLLEGE){
                const headerItem = new HeaderItem();
                headerItem.id = data.id;
                headerItem.name = "College of " + data.name;
                const newHeaders = this.state.headers.slice();
                newHeaders.push(headerItem)
                this.fetchData(LEVEL.DEPARTMENT, data.id,this.buildFilter(this.state.collegeFilterTree));
                this.setState({...this.state,headers: newHeaders,currentLevel: LEVEL.DEPARTMENT, currentSelectedID: data.id, dataRequestState: RequestState.LOADING});
            }else if(this.state.currentLevel === LEVEL.DEPARTMENT){
                const headerItem = new HeaderItem();
                headerItem.id = data.id;
                headerItem.name = data.name;
                const newHeaders = this.state.headers.slice();
                newHeaders.push(headerItem)
                this.fetchData(LEVEL.FACULTY, data.id,this.buildFilter(this.state.collegeFilterTree));
                this.setState({...this.state,headers: newHeaders,currentLevel: LEVEL.FACULTY, currentSelectedID: data.id, dataRequestState: RequestState.LOADING});
            }else{
                this.props.history.push(`/faculty/${data.id}`)
            }
        }
    }

    private onBarClick = (data: AggregateEnity) => {
        this.props.history.push(`/faculty/${data.id}`)
    }

    private renderBarChart = (data: AggregateEnity[]) => {
        let width;
        if(data.length >= 10){
            width = data.length * 80
        }else{
            width = 900
        }
        data.sort((item1: AggregateEnity, item2: AggregateEnity)=>{
            const name1 = item1.name.toLowerCase();
            const name2 = item2.name.toLowerCase();
            if(name1 < name2){
                return -1;
            }else if(name1 > name2){
                return 1
            }else{
                return 0;
            }
        })
        return (
            <div id="barChartContainer" className={css(styles.barChartContainer)}>
                <ComposedChart data={data}
                    width={width}
                    height={420}
                    barGap={40}
                    margin={{top: 30, right: 30, left: 20, bottom: 40}}
                >
                    <XAxis dataKey="name" interval={0} tick={<HorizontalAxisTick angle={-45} textAnchor={"end"} fontSize={12}/>} />
                    <YAxis tickFormatter={this.tickFormatter} tick={{fontSize: 11}} /> } />
                    <Legend align="left" verticalAlign={"top"} height={36} />
                    <Tooltip content={<CombinedToolTip 
                                                    labelName={"Faculty"}
                                                    valueLabel = {"Amount"}
                                                    valueFormatter = {this.tickFormatter}
                                                    />}/>
                    <Bar name="Proposals" dataKey="proposal_amount" stackId="1" barSize={50} fill={"#e6194B"} onClick={this.onBarClick}>
                        {
                            data.map(this.buildBar2)
                        }
                    </Bar>
                    <Bar name="Award" dataKey="award_amount" stackId="1" barSize={50} fill={"#ffe119"} onClick={this.onBarClick} >
                        {
                            data.map(this.buildBar1)
                        }
                    </Bar>
                    <Bar name="Expenditure" dataKey="expenditure_amount" stackId="1" barSize={50}  fill={"#4363d8"} onClick={this.onBarClick} >
                        {
                            data.map(this.buildBar3)
                        }
                    </Bar>
                </ComposedChart>
            </div>
        );
    }

    private isViewDisabled = (view: VIEW) => {
        if(this.state.currentLevel === LEVEL.FACULTY){
            return true;
        }else{
            if(view === VIEW.EXPENDITURE){
                return this.state.selectedAggregate === AGGREGATE.COUNT;
            }else if(view === VIEW.PUBLICATION){
                return this.state.selectedAggregate === AGGREGATE.AMOUNT;    
            }else{
                return false;
            }
        }
    }

    private isAggregateDisabled = (aggregate: AGGREGATE) => {
        if(this.state.currentLevel === LEVEL.FACULTY){
            return true;
        }else{
            if(aggregate === AGGREGATE.AMOUNT){
                return this.state.selectedView === VIEW.PUBLICATION;
            }else if(aggregate === AGGREGATE.COUNT){
                return this.state.selectedView === VIEW.EXPENDITURE;    
            }else{
                return false;
            }
        }
    }

    private tickFormatter = (value: string) => {
        return "$" + millify(+value);
    }
   
    private buildBar1 = (_entry: AggregateEnity,index: number) => {
        return(
            <Cell cursor="pointer"  key={`cell-${index}`}/>
        );
    }
    
    private buildBar2 = (_entry: AggregateEnity,index: number) => {
        return(
            <Cell cursor="pointer"  key={`cell-${index}`}/>
        );        
    }

    private buildBar3 = (_entry: AggregateEnity,index: number) => {
        return(
            <Cell cursor="pointer" key={`cell-${index}`}/>
        );        
    }

    private buildHeaderItem = (entity: HeaderItem, index: number) => {
        return (
            <div key={index} className={css(styles.headerItem)} onClick={(e: any)=>{this.onHeaderClick(entity, index)}}>
                <div className={css(styles.headerItemLast)} >
                    {entity.name}
                </div>
                <div>
                    /
                </div>
            </div>
        )
    }

    private onHeaderClick = (header: HeaderItem, index: number) => {
        if(index === 0){
            this.fetchData(LEVEL.COLLEGE, header.id, this.buildFilter(this.state.collegeFilterTree));
            const newHeaders = this.state.headers.slice(0,1);
            this.setState({...this.state,headers: newHeaders,currentLevel: LEVEL.COLLEGE, currentSelectedID: header.id, dataRequestState: RequestState.LOADING});
        }else if(index === 1){
            this.fetchData(LEVEL.DEPARTMENT, header.id,this.buildFilter(this.state.collegeFilterTree));  
            const newHeaders = this.state.headers.slice(0,2);
            this.setState({...this.state,headers: newHeaders,currentLevel: LEVEL.DEPARTMENT, currentSelectedID: header.id, dataRequestState: RequestState.LOADING});  
        }else if(index === 2){
            this.fetchData(LEVEL.FACULTY,header.id,this.buildFilter(this.state.collegeFilterTree));  
            const newHeaders = this.state.headers.slice(0,3);
            this.setState({...this.state,headers: newHeaders,currentLevel: LEVEL.FACULTY, currentSelectedID: header.id, dataRequestState: RequestState.LOADING});  
        }
    }

    private buildParentTreeItem = (entity: TreeNodeParent, index: number) => {

        let children;
        let icon;
        if(entity.is_expanded){
            children = (
                <React.Fragment>
                    {entity.children.map(this.buildChildTreeItem)}
                </React.Fragment>
            )
            icon = (
                <FontAwesomeIcon icon={faMinus} className={css(styles.expandIcon)}/>
            );
        }else{
            children = (
                <React.Fragment>

                </React.Fragment>
            );
            icon = (
                <FontAwesomeIcon icon={faPlus} className={css(styles.expandIcon)}/>
            );
        }

        let checkboxIcon;
        if(entity.checked_state === CheckState.CHECKED){
            checkboxIcon = (
                <React.Fragment>
                    <FontAwesomeIcon icon={["far","check-square"]} className={css(styles.checkBoxIcon)} />
                </React.Fragment>
            )
        }else if(entity.checked_state === CheckState.UNCHECKED){
            checkboxIcon = (
                <React.Fragment>
                    <FontAwesomeIcon icon={["far","square"]} className={css(styles.checkBoxIcon)} />
                </React.Fragment>
            )
        }else{
            checkboxIcon = (
                <React.Fragment>
                    <FontAwesomeIcon icon={["fas","minus-square"]} className={css(styles.checkBoxIcon)} />
                </React.Fragment>
            )
        }

        return (
        <div key={index} >
            <div className={css(styles.parentEntity)} onClick={(event: any)=>this.onTreeParentClick(entity, index)} >

                <div onClick={(event: any)=>{event.stopPropagation();this.onParentCheckChange(entity, index)}}>
                        {checkboxIcon}
                </div>
                
                <div className={css(styles.title)} >
                    {entity.label}
                </div>
                {icon}
            </div>
            <div>
                {children}
            </div>
        </div>)
    }

    private buildChildTreeItem = (entity: TreeNodeChild, index: number) => {

        let children;
        let icon;
        if(entity.children.length > 0){
            if(entity.is_expanded){
                children = (
                    <React.Fragment>
                        {entity.children.map(this.buildLeafChildTreeItem)}
                    </React.Fragment>
                )
                icon = (
                    <div onClick={(event: any)=>{event.stopPropagation();this.onChildExpandClick(entity, index)}} >
                        <FontAwesomeIcon icon={faMinus} className={css(styles.expandIconChild)} />
                    </div>
                );
            }else{
                children = (
                    <React.Fragment>
    
                    </React.Fragment>
                );
                icon = (
                    <div onClick={(event: any)=>{event.stopPropagation();this.onChildExpandClick(entity, index)}} >
                        <FontAwesomeIcon icon={faPlus} className={css(styles.expandIconChild)} />
                    </div>
                );
            }
        }else{
            children = (
                <React.Fragment>

                </React.Fragment>
            );
            icon = (
                <React.Fragment>

                </React.Fragment>
            );
        }    

        let checkboxIcon;
        if(entity.checked_state === CheckState.CHECKED){
            checkboxIcon = (
                <React.Fragment>
                    <FontAwesomeIcon icon={["far","check-square"]} className={css(styles.checkBoxIcon)} />
                </React.Fragment>
            )
        }else if(entity.checked_state === CheckState.UNCHECKED){
            checkboxIcon = (
                <React.Fragment>
                    <FontAwesomeIcon icon={["far","square"]} className={css(styles.checkBoxIcon)} />
                </React.Fragment>
            )
        }else{
            checkboxIcon = (
                <React.Fragment>
                    <FontAwesomeIcon icon={["fas","minus-square"]} className={css(styles.checkBoxIcon)} />
                </React.Fragment>
            )
        }
        
        return (
            <div key={index}>
                <div className={css(styles.childEntity)}  onClick={(event: any)=>{this.onTreeChildClick(entity, index)}} >
                    <div onClick={(event: any)=>{this.onChildCheckChange(entity, index)}}>
                        {checkboxIcon}
                    </div> 
                    {entity.label}
                    {icon}
                </div>
                {children}
            </div>
        )
    }

    private onChildExpandClick = (childEntity: TreeNodeChild, index: number) => {
        //clone the original list
        const newList = [...this.state.collegeFilterTree];
        
        //update the child
        const newItem = {...childEntity};
        newItem.is_expanded = !childEntity.is_expanded;
        
        //update the parent
        const newParent = {...this.state.collegeFilterTree[newItem.parent]}
        const newChildList = [...newParent.children];
        newChildList[index] = newItem;
        newParent.children = newChildList;

        //finally update the top list
        newList[newItem.parent] = newParent;
        this.setState({...this.state,collegeFilterTree: newList});
    }

    private buildLeafChildTreeItem = (entity: TreeNodeLeafChild, index: number) => {

        let checkboxIcon;
        if(entity.is_checked){
            checkboxIcon = (
                <React.Fragment>
                    <FontAwesomeIcon icon={["far","check-square"]} className={css(styles.checkBoxIcon)} />
                </React.Fragment>
            )
        }else{
            checkboxIcon = (
                <React.Fragment>
                    <FontAwesomeIcon icon={["far","square"]} className={css(styles.checkBoxIcon)} />
                </React.Fragment>
            )
        }

        return (
        <div className={css(styles.leafChildEntity)} key={index} onClick={(event: any)=>{this.onTreeLeafChildClick(entity, index)}} >
            <div >
                {checkboxIcon}
            </div>   
            {entity.label}
        </div>
        
        )
    }

    private onTreeParentClick = (item: TreeNodeParent, index: number) => {
        const newList = [...this.state.collegeFilterTree];
        const newItem = {...item};
        newItem.is_expanded = !item.is_expanded;
        newList[index] = newItem;
        this.setState({...this.state,collegeFilterTree: newList});
    }

    private onTreeChildClick = (item: TreeNodeChild, index: number) => {
        this.onChildCheckChange(item, index);
    }

    private onTreeLeafChildClick = (item: TreeNodeLeafChild, index: number) => {
        this.onLeafChildCheckChange(item, index);
    }

    private onParentCheckChange = (item: TreeNodeParent, index: number) => {
        const newList = this.state.collegeFilterTree.slice();
        const newItem = {...item};
        if(item.checked_state === CheckState.CHECKED){
            newItem.checked_state = CheckState.UNCHECKED;
        }else if(item.checked_state === CheckState.PARTIALLY_CHECKED){
            newItem.checked_state = CheckState.UNCHECKED;
        }else{
            newItem.checked_state = CheckState.CHECKED;
        }
        const newChildren = newItem.children.map((childItem: TreeNodeChild)=>{
            const newChildItem = {...childItem};
            newChildItem.checked_state = newItem.checked_state;
            return newChildItem;
        })
        newItem.children = newChildren;
        newList[index] = newItem;

        //build the filter
        const filter = this.buildFilter(newList)

        //fetch the data
        this.fetchData(this.state.currentLevel, this.state.currentSelectedID,filter)

        this.setState({...this.state,collegeFilterTree: newList});
    }

    private onChildCheckChange = (item: TreeNodeChild, index: number) => {
        
        const parent = this.state.collegeFilterTree[item.parent];
        const newChildItem = {...item};
        if(item.checked_state === CheckState.CHECKED){
            newChildItem.checked_state  = CheckState.UNCHECKED;
        }else if(item.checked_state === CheckState.PARTIALLY_CHECKED){
            newChildItem.checked_state  = CheckState.UNCHECKED;
        }else{
            newChildItem.checked_state = CheckState.CHECKED;
        }

        //untick all the children
        const newLeafChildren = [...newChildItem.children].map((leafChildItem: TreeNodeLeafChild)=>{
            const newLeafChildItem = {...leafChildItem};
            newLeafChildItem.is_checked = (newChildItem.checked_state === CheckState.CHECKED);
            return newLeafChildItem;
        })

        newChildItem.children = newLeafChildren;

        const newChildren = [...parent.children];
        newChildren[index] = newChildItem;
        
        //calculate new checked_state for the parent
        let numberOfChecks = 0;
        let isAnyPartial = false;
        for(const child of newChildren){
            if(child.checked_state === CheckState.CHECKED){
                numberOfChecks = numberOfChecks + 1;
            }else if(child.checked_state === CheckState.PARTIALLY_CHECKED){
                isAnyPartial = true;
            }
        }
        let new_parent_checked_state = CheckState.UNCHECKED;
        if(numberOfChecks === newChildren.length){
            new_parent_checked_state = CheckState.CHECKED;
        }else if(isAnyPartial || numberOfChecks > 0 ){
            new_parent_checked_state = CheckState.PARTIALLY_CHECKED;
        }
        //update the parent with new child list
        const newParent = {...parent};
        newParent.children = newChildren;
        newParent.checked_state = new_parent_checked_state;

        //replace the parent in original list
        const newList = [...this.state.collegeFilterTree];
        newList[item.parent] = newParent;

        //build the filter
        const filter = this.buildFilter(newList)

        //fetch the data
        this.fetchData(this.state.currentLevel, this.state.currentSelectedID,filter)

        this.setState({...this.state,collegeFilterTree: newList});                
    }

    private onLeafChildCheckChange = (leafItem: TreeNodeLeafChild, index: number) => {                   
        const newLeafItem = {...leafItem};
        newLeafItem.is_checked = !leafItem.is_checked;

        const newParent = {...this.state.collegeFilterTree[leafItem.superParent]};
        const newChildItem = {...newParent.children[leafItem.parent]}
                        
        //update the childItem with new leaf child list and checked state
        const newLeafChildren = [...newChildItem.children];
        newLeafChildren[index] = newLeafItem;
        newChildItem.children = newLeafChildren;
        
        //calculate new checked_state for the child item
        let numberOfChecks = 0;
        for(const child of newChildItem.children){
            if(child.is_checked){
                numberOfChecks = numberOfChecks + 1;
            }
        }
        let new_child_checked_state = CheckState.UNCHECKED;
        if(numberOfChecks === newChildItem.children.length){
            new_child_checked_state = CheckState.CHECKED;
        }else if(numberOfChecks > 0 ){
            new_child_checked_state = CheckState.PARTIALLY_CHECKED;
        }
        newChildItem.checked_state = new_child_checked_state;
        
        //update the parent with new child list
        const newChildren = [...newParent.children];
        newChildren[newLeafItem.parent] = newChildItem; 
        newParent.children = newChildren;
        
        //calculate new checked_state for the parent
        numberOfChecks = 0;
        let isAnyPartial = false;
        for(const child of newParent.children){
            if(child.checked_state === CheckState.CHECKED){
                numberOfChecks = numberOfChecks + 1;
            }else if(child.checked_state === CheckState.PARTIALLY_CHECKED){
                isAnyPartial = true;
            }
        }
        let new_parent_checked_state = CheckState.UNCHECKED;
        if(numberOfChecks === newParent.children.length){
            new_parent_checked_state = CheckState.CHECKED;
        }else if(isAnyPartial || numberOfChecks > 0 ){
            new_parent_checked_state = CheckState.PARTIALLY_CHECKED;
        }
        
        //update the parent with new checked state
        newParent.checked_state = new_parent_checked_state;

        //replace the parent in original list
        const newList = [...this.state.collegeFilterTree];
        newList[leafItem.superParent] = newParent;

        //build the filter
        const filter = this.buildFilter(newList)

        //fetch the data
        this.fetchData(this.state.currentLevel, this.state.currentSelectedID,filter)

        this.setState({...this.state,collegeFilterTree: newList});                
    }
    
    private buildFilter = (treeNodes: TreeNodeParent[]): AggregateFilterEntity[] => {
        
        const entities: AggregateFilterEntity[] = [];
        for(const parent of treeNodes){
            //if parent is checked then all children are checked too. So add everything
            if(parent.checked_state === CheckState.CHECKED || parent.checked_state === CheckState.PARTIALLY_CHECKED){
                const entity = new AggregateFilterEntity();
                entity.entity_id = parent.id;
                entity.name = parent.label;

                // if child is check or partially checked then add it to children
                for(const child of parent.children){
                   
                    if(child.checked_state === CheckState.CHECKED || child.checked_state === CheckState.PARTIALLY_CHECKED){
                        const childEntity = new AggregateFilterEntity();
                        childEntity.entity_id = child.id;
                        childEntity.name = child.label;
                        
                        //if leaf child is checked then add it to children
                        for(const leafChild of child.children){
                            if(leafChild.is_checked){
                                const leafChildEntity = new AggregateFilterEntity();
                                leafChildEntity.entity_id = leafChild.id;
                                leafChildEntity.name = leafChild.label;
                                childEntity.children.push(leafChildEntity);
                            }
                        }                      
                        
                        entity.children.push(childEntity);
                    }
                }

                entities.push(entity);
            }
        }
        console.log(entities);
        return entities;
    }

}



const PieLabel = (props: any) => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, outerRadius,
      fill, payload, percent, aggregate } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 50) * cos;
    const my = cy + (outerRadius + 60) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';
    
    let countLabel;

    if(aggregate === AGGREGATE.AMOUNT){
        countLabel = "$"+ millify(+payload.count)
    }else{
        countLabel = payload.count
    }
    
    return (
      <g className={css(styles.hover)} >
        
        
        <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none"/>
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none"/>
        <text fontSize={12} x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${payload.name} ${countLabel} (${(percent * 100).toFixed(2)}%)`}</text>
      </g>
    );
};
  

const PieActiveShape = (props: any) => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle,
      fill, payload, percent, aggregate } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 50) * cos;
    const my = cy + (outerRadius + 60) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    let countLabel;

    if(aggregate === AGGREGATE.AMOUNT){
        countLabel = "$"+ millify(+payload.count)
    }else{
        countLabel = payload.count
    }

  
    return (
      <g className={css(styles.hover)} >
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
        />
        <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none"/>
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none"/>
        <text fontSize={12} x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${payload.name} ${countLabel} (${(percent * 100).toFixed(2)}%)`}</text>
      </g>
    );
};


// WEBPACK FOOTER //
// ./src/pages/AggregateCollege.tsx